import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuthContext } from '../../contexts/AuthProvider';
import { useSessionContext } from '../../contexts/SessionProvider';
import { ParticipantData } from '../../types/session';
import LocalVideoStream from './LocalVideoStream';
import RemoteVideoStream from './RemoteVideoStream';
import SessionController from './SessionController';

const VideoStreamContainer = () => {
  // integration of react hooks here
  const [localUser, setLocalUser] = useState<ParticipantData>();
  const [remoteUser, setRemoteUser] = useState<ParticipantData>();

  // integration of context hooks here
  const { socketData, webSocket, mutedStatus, callHangUpHandler } =
    useSessionContext();

  const { currentUser, currentUserType } = useAuthContext();

  // integration of react-router-dom hooks here
  const navigate = useNavigate();

  // sending user id through websocket here when the connection is established
  useMemo(() => {
    if (webSocket) {
      console.log('CALLING DEFAULT WEBSOCKET!!');
      webSocket.send(
        JSON.stringify(
          currentUserType === 'client'
            ? {
                is_client_audio_muted: mutedStatus.is_client_audio_muted,
                is_client_video_muted: mutedStatus.is_client_video_muted,
                is_client_screen_shared: mutedStatus.is_client_screen_shared,
                client_id: currentUser?.id,
                is_participant_allow: 'pending',
              }
            : {
                is_associate_audio_muted: mutedStatus.is_associate_audio_muted,
                is_associate_video_muted: mutedStatus.is_associate_video_muted,
                is_associate_screen_shared:
                  mutedStatus.is_associate_screen_shared,
                associate_id: currentUser?.id,
                is_participant_allow: 'pending',
              }
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [webSocket, currentUserType, currentUser]);

  // parsing & storing socket data here
  useEffect(() => {
    if (socketData) {
      try {
        const parsedSocketData = JSON.parse(socketData.session as string)
          .data as Array<ParticipantData>;
        console.log('PARSED SOCKED DATA: ', parsedSocketData);

        const lUser = parsedSocketData.find(
          (session) => session.participant_id === currentUser?.id
        );

        const rUser = parsedSocketData.find(
          (session) => session.participant_id !== currentUser?.id
        );

        if (lUser) {
          setLocalUser(lUser);
        }

        if (rUser) {
          setRemoteUser(rUser);
        }
      } catch (error) {}
    }
  }, [socketData, currentUser?.id]);

  useEffect(() => {
    if (
      mutedStatus.is_participant_allow === 'rejected' &&
      currentUserType === 'client'
    ) {
      console.log('rejected!!');

      callHangUpHandler();
      navigate('/appointment/history/');

      toast.warn('Associate Rejected Your Join Request!!', {
        toastId: 'reject-join-session',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mutedStatus]);

  // rendering video stream container section component here
  return (
    <>
      {/* {localUser ? ( */}
      {/* // currentUserType === 'client' &&
        // mutedStatus.is_participant_allow === 'pending' ? (
        //   <SessionLobby />
        // ) : ( */}
      <section className='size-full'>
        <RemoteVideoStream remoteUser={remoteUser as ParticipantData} />
        <LocalVideoStream localUser={localUser as ParticipantData} />
        <SessionController
          localUser={localUser as ParticipantData}
          remoteUser={remoteUser as ParticipantData}
        />
      </section>
      {/* // ) : // )
      // null} */}
    </>
  );
};

export default VideoStreamContainer;
